import script from "./GradientText.vue?vue&type=script&setup=true&lang=js"
export * from "./GradientText.vue?vue&type=script&setup=true&lang=js"

import "./GradientText.vue?vue&type=style&index=0&id=5e6ee0da&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6ee0da"]])

export default __exports__